import { createFileRoute } from "@tanstack/react-router";
import { BpPage } from "@/components/bp/bpPage";

export const Route = createFileRoute("/")({
  component: BpPage,
});
